import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogFooter } from "src/components/ui/dialog";
import Col from "react-bootstrap/esm/Col";
import { Button } from "src/components/ui/button";
import Divider from "src/components/ui/divider";
import BookCall from "src/components/book-call";
import Text from "src/components/ui/text";
import { useMariaPackage } from "src/hooks/dashboard";
import { useCreatePackageOrderRequest } from "src/hooks/api/membership";
import { useNavigate } from "react-router-dom";

interface IAdvanceTier {
  isModalShow: boolean;
  closeModal: () => void;
}

export const AdvanceTier = ({ isModalShow, closeModal }: IAdvanceTier) => {
  const { t } = useTranslation();
  const { data: mariaPackage, isLoading: isMariaPackageLoading } = useMariaPackage();
  const { data: orderData, mutate, status } = useCreatePackageOrderRequest();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (!mariaPackage?.id) return;

    mutate({
      id: mariaPackage.id,
      is_installment: false,
    });
  };

  React.useEffect(() => {
    if (status === "success" && orderData?.data) {
      if (orderData.data.package.area_level === 0) {
        navigate(`/order/checkout/${orderData.data.id}/payment-information/`);
      } else {
        navigate(`/order/checkout/${orderData.data.id}/location/`);
      }
    }
  }, [status, orderData]);

  return (
    <Dialog open={isModalShow} onOpenChange={closeModal}>
      <DialogContent className="p-4 md:p-6 overflow-y-auto overflow-x-hidden flex max-h-screen max-w-full flex-col md:min-w-[400px] md:max-w-[450px] w-full min-h-screen md:min-h-fit">
        <DialogTitle>{`Oops! This feature is only available with the ${mariaPackage?.name} tier Subscription.`}</DialogTitle>
        <DialogDescription className="sr-only" />
        <div className="flex-1 mb-1">
          <Col xs={{ span: 22, offset: 1 }}>
            <Text fontSize="7" alignment="start" style={{ marginBottom: 16 }}>
              {`Subscribe to ${mariaPackage?.name} tier to access all of our features & Maria.Ai:`}
            </Text>
            <ul className="av-list av-list--small">
              <li className="av-list__item">{t("See all sublease friendly properties in our arbitrage marketplace")}</li>
              <li className="av-list__item">{t("Request properties in a specific location with the help of Maria.Ai")}</li>
              <li className="av-list__item">{t("Invite and match with landlords")}</li>
              <li className="av-list__item">{t("Select a vetted location to have Airvana search for you")}</li>
              <li className="av-list__item">{t("See all regulations and receive alerts when new ordinances are in play")}</li>
              <li className="av-list__item">{t("Explore deals across hundreds of pre vetted markets")}</li>
              <li className="av-list__item">{t("AND everything in our standard subscription!")}</li>
            </ul>
          </Col>
        </div>
        <DialogFooter className="flex !flex-col pb-0">
          <Button className="w-100" disabled={isMariaPackageLoading} onClick={handleUpgrade}>
            {isMariaPackageLoading ? t("Loading...") : t("Upgrade tier")}
          </Button>
          <Divider className="w-100" text={t("or") as string} />
          <BookCall
            className="w-100 !text-foreground"
            buttonVariant="outline"
            buttonText={isMariaPackageLoading ? t("Loading...") : t("Request Demo")}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
